module.exports = __webpack_public_path__ + "public/SideMenuIcons/cancelledBooking.svg?f148a533";